/* tslint:disable */
/* eslint-disable */
/**
 * cz.partners.bank.termination.account.cab.boa
 * Current Account Basic Termination for Back Office Application
 *
 * The version of the OpenAPI document: 1.0
 * Contact: cestmir.ruzicka@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AmountIsoCurrencyV2x0
 */
export interface AmountIsoCurrencyV2x0 {
    /**
     * 
     * @type {number}
     * @memberof AmountIsoCurrencyV2x0
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof AmountIsoCurrencyV2x0
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GetCloseDateCurrentAccountBasicTerminationRequestReasonV1 = {
    CLIENT_REQUEST: 'ATR_CLIENT_REQUEST',
    AML: 'ATR_AML',
    FRAUD: 'ATR_FRAUD',
    TOC_VIOLATION: 'ATR_TOC_VIOLATION',
    BANK_WITH_NOTICE_PERIOD: 'ATR_BANK_WITH_NOTICE_PERIOD',
    LIMITATION_OF_AUTONOMY: 'ATR_LIMITATION_OF_AUTONOMY',
    INSOLVENCY: 'ATR_INSOLVENCY',
    INHERITANCE: 'ATR_INHERITANCE'
} as const;

export type GetCloseDateCurrentAccountBasicTerminationRequestReasonV1 = typeof GetCloseDateCurrentAccountBasicTerminationRequestReasonV1[keyof typeof GetCloseDateCurrentAccountBasicTerminationRequestReasonV1];


/**
 * 
 * @export
 * @interface GetCloseDateCurrentAccountBasicTerminationRequestV1
 */
export interface GetCloseDateCurrentAccountBasicTerminationRequestV1 {
    /**
     * 
     * @type {string}
     * @memberof GetCloseDateCurrentAccountBasicTerminationRequestV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {GetCloseDateCurrentAccountBasicTerminationRequestReasonV1}
     * @memberof GetCloseDateCurrentAccountBasicTerminationRequestV1
     */
    'reason': GetCloseDateCurrentAccountBasicTerminationRequestReasonV1;
    /**
     * Unique identifier of the PID client
     * @type {string}
     * @memberof GetCloseDateCurrentAccountBasicTerminationRequestV1
     */
    'initiatorPidUuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1 = {
    MANUAL: 'MANUAL',
    AUTOMATIC: 'AUTOMATIC'
} as const;

export type GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1 = typeof GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1[keyof typeof GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1];


/**
 * 
 * @export
 * @interface GetCloseDateCurrentAccountBasicTerminationResponseV1
 */
export interface GetCloseDateCurrentAccountBasicTerminationResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof GetCloseDateCurrentAccountBasicTerminationResponseV1
     */
    'closeDate': string;
    /**
     * 
     * @type {GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1}
     * @memberof GetCloseDateCurrentAccountBasicTerminationResponseV1
     */
    'closeDateType': GetCloseDateCurrentAccountBasicTerminationResponseGetCloseDateTypeV1;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1 = {
    CLIENT_REQUEST: 'ATR_CLIENT_REQUEST',
    AML: 'ATR_AML',
    FRAUD: 'ATR_FRAUD',
    TOC_VIOLATION: 'ATR_TOC_VIOLATION',
    BANK_WITH_NOTICE_PERIOD: 'ATR_BANK_WITH_NOTICE_PERIOD',
    LIMITATION_OF_AUTONOMY: 'ATR_LIMITATION_OF_AUTONOMY',
    INSOLVENCY: 'ATR_INSOLVENCY',
    INHERITANCE: 'ATR_INHERITANCE'
} as const;

export type GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1 = typeof GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1[keyof typeof GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1];


/**
 * 
 * @export
 * @interface GetSettlementAccountCurrentAccountBasicTerminationRequestV1
 */
export interface GetSettlementAccountCurrentAccountBasicTerminationRequestV1 {
    /**
     * 
     * @type {string}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationRequestV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationRequestV1
     */
    'reason': GetSettlementAccountCurrentAccountBasicTerminationRequestReasonV1;
    /**
     * Unique identifier of the PID client
     * @type {string}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationRequestV1
     */
    'initiatorPidUuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1 = {
    APPLICANT: 'APPLICANT',
    CO_OWNER: 'CO_OWNER',
    BANK: 'BANK'
} as const;

export type GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1 = typeof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1[keyof typeof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1];


/**
 * 
 * @export
 * @interface GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1
 */
export interface GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1 {
    /**
     * 
     * @type {string}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1
     */
    'accountName'?: string;
    /**
     * 
     * @type {GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1
     */
    'accountOwnerType': GetSettlementAccountCurrentAccountBasicTerminationResponseAccountAccountOwnerTypeV1;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1 = {
    MANUAL: 'MANUAL',
    AUTOMATIC: 'AUTOMATIC'
} as const;

export type GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1 = typeof GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1[keyof typeof GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1];


/**
 * 
 * @export
 * @interface GetSettlementAccountCurrentAccountBasicTerminationResponseV1
 */
export interface GetSettlementAccountCurrentAccountBasicTerminationResponseV1 {
    /**
     * 
     * @type {GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseV1
     */
    'settlementType': GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1;
    /**
     * 
     * @type {Array<GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1>}
     * @memberof GetSettlementAccountCurrentAccountBasicTerminationResponseV1
     */
    'settlementAccounts': Array<GetSettlementAccountCurrentAccountBasicTerminationResponseAccountV1>;
}


/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
 */
export interface PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'zis'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1
     */
    'feeTypeId'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1 = {
    BANK_FOUR_EYES_CHECK: 'BANK_FOUR_EYES_CHECK',
    CLIENT_SIGNATURE: 'CLIENT_SIGNATURE'
} as const;

export type PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1 = typeof PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1[keyof typeof PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1];


/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1
 */
export interface PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1
     */
    'swift'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1
     */
    'paymentReference'?: string;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1
     */
    'accountOwner'?: PrepareCurrentAccountBasicTerminationRequestAccountOwnerV1;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PrepareCurrentAccountBasicTerminationRequestReasonV1 = {
    FEE_TOO_HIGH: 'ATR_FEE_TOO_HIGH',
    NOT_ENOUGH_PRODUCTS: 'ATR_NOT_ENOUGH_PRODUCTS',
    INTEREST_RATE: 'ATR_INTEREST_RATE',
    CONFUSING: 'ATR_CONFUSING',
    OTHER: 'ATR_OTHER',
    AML: 'ATR_AML',
    FRAUD: 'ATR_FRAUD',
    TOC_VIOLATION: 'ATR_TOC_VIOLATION',
    BANK_WITH_NOTICE_PERIOD: 'ATR_BANK_WITH_NOTICE_PERIOD',
    LIMITATION_OF_AUTONOMY: 'ATR_LIMITATION_OF_AUTONOMY',
    INSOLVENCY: 'ATR_INSOLVENCY',
    INHERITANCE: 'ATR_INHERITANCE'
} as const;

export type PrepareCurrentAccountBasicTerminationRequestReasonV1 = typeof PrepareCurrentAccountBasicTerminationRequestReasonV1[keyof typeof PrepareCurrentAccountBasicTerminationRequestReasonV1];


/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1
 */
export interface PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1
     */
    'iban': string;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestSumV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1
     */
    'sum'?: PrepareCurrentAccountBasicTerminationRequestSumV1;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1
     */
    'internationalAccountInfo'?: PrepareCurrentAccountBasicTerminationRequestInternationalAccountInfoV1;
}
/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationRequestSumV1
 */
export interface PrepareCurrentAccountBasicTerminationRequestSumV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestSumV1
     */
    'value': string;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestUnitV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestSumV1
     */
    'unit': PrepareCurrentAccountBasicTerminationRequestUnitV1;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1 = {
    IMMEDIATELY: 'IMMEDIATELY',
    NEXT_DAY: 'NEXT_DAY',
    STANDARD_DAY: 'STANDARD_DAY'
} as const;

export type PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1 = typeof PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1[keyof typeof PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const PrepareCurrentAccountBasicTerminationRequestUnitV1 = {
    PERCENT: 'PERCENT',
    AMOUNT: 'AMOUNT'
} as const;

export type PrepareCurrentAccountBasicTerminationRequestUnitV1 = typeof PrepareCurrentAccountBasicTerminationRequestUnitV1[keyof typeof PrepareCurrentAccountBasicTerminationRequestUnitV1];


/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationRequestV1
 */
export interface PrepareCurrentAccountBasicTerminationRequestV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {Array<PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1>}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'settlementAccounts': Array<PrepareCurrentAccountBasicTerminationRequestSettlementAccountV1>;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestReasonV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'reason': PrepareCurrentAccountBasicTerminationRequestReasonV1;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'authorisationType': PrepareCurrentAccountBasicTerminationRequestAuthorisationTypeV1;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'closeDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'documentUuids'?: Array<string>;
    /**
     * Unique identifier of the PID client
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'initiatorPidUuid'?: string;
    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1}
     * @memberof PrepareCurrentAccountBasicTerminationRequestV1
     */
    'testClosingDateType'?: PrepareCurrentAccountBasicTerminationRequestTestClosingDateTypeV1;
}


/**
 * 
 * @export
 * @interface PrepareCurrentAccountBasicTerminationResponseV1
 */
export interface PrepareCurrentAccountBasicTerminationResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof PrepareCurrentAccountBasicTerminationResponseV1
     */
    'requestedOperationUuid': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypeV1 = {
    SHARED_PRODUCT_NOTIFICATION: 'SHARED_PRODUCT_NOTIFICATION',
    OVERDRAFT_IN_DEBIT: 'OVERDRAFT_IN_DEBIT',
    OVERDRAFT_IN_CREDIT: 'OVERDRAFT_IN_CREDIT',
    LOAN_PRODUCT_EXISTS: 'LOAN_PRODUCT_EXISTS',
    BALANCE_IN_DEBIT: 'BALANCE_IN_DEBIT',
    EXECUTION_EXISTS: 'EXECUTION_EXISTS',
    BLOCKING_EXISTS: 'BLOCKING_EXISTS',
    CARD_EXISTS: 'CARD_EXISTS',
    EXISTING_PAYMENTS: 'EXISTING_PAYMENTS',
    EXISTING_TERMINATION: 'EXISTING_TERMINATION',
    EXISTING_TRANSITION: 'EXISTING_TRANSITION',
    SUBACCOUNT_EXISTS: 'SUBACCOUNT_EXISTS'
} as const;

export type TypeV1 = typeof TypeV1[keyof typeof TypeV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const ValidateCurrentAccountBasicTerminationRequestReasonV1 = {
    CLIENT_REQUEST: 'ATR_CLIENT_REQUEST',
    AML: 'ATR_AML',
    FRAUD: 'ATR_FRAUD',
    TOC_VIOLATION: 'ATR_TOC_VIOLATION',
    BANK_WITH_NOTICE_PERIOD: 'ATR_BANK_WITH_NOTICE_PERIOD',
    LIMITATION_OF_AUTONOMY: 'ATR_LIMITATION_OF_AUTONOMY',
    INSOLVENCY: 'ATR_INSOLVENCY',
    INHERITANCE: 'ATR_INHERITANCE'
} as const;

export type ValidateCurrentAccountBasicTerminationRequestReasonV1 = typeof ValidateCurrentAccountBasicTerminationRequestReasonV1[keyof typeof ValidateCurrentAccountBasicTerminationRequestReasonV1];


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationRequestV1
 */
export interface ValidateCurrentAccountBasicTerminationRequestV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationRequestV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationRequestReasonV1}
     * @memberof ValidateCurrentAccountBasicTerminationRequestV1
     */
    'reason': ValidateCurrentAccountBasicTerminationRequestReasonV1;
    /**
     * Unique identifier of the PID client
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationRequestV1
     */
    'initiatorPidUuid'?: string;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1
     */
    'currencyCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1
     */
    'isMain': boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1
     */
    'availableBalance': number;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseAccountDetailV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
     */
    'accountName': string;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
     */
    'productCode': ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1;
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseAccountDetailV1
     */
    'currencies': Array<ValidateCurrentAccountBasicTerminationResponseAccountCurrencyV1>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1 = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    ACCOUNT_PROTECTED: 'OP_ACCOUNT_PROTECTED',
    TERM_DEPOSIT: 'OP_TERM_DEPOSIT'
} as const;

export type ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1 = typeof ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1[keyof typeof ValidateCurrentAccountBasicTerminationResponseAccountProductCodeV1];


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOf
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters
 */
export interface ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters {
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1AllOfMessageParameters
     */
    'balanceDebitAmount': AmountIsoCurrencyV2x0;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseBlockingExistsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseBlockingExistsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseBlockingExistsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseCardExistsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseCardExistsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseCardExistsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseDirectDebitV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'directDebitName': string;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'recipient': ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'amount': AmountIsoCurrencyV2x0;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'periodicity': ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseDirectDebitV1
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExecutionExistsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseExecutionExistsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExecutionExistsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOf
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters {
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseDirectDebitV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters
     */
    'directDebits'?: Array<ValidateCurrentAccountBasicTerminationResponseDirectDebitV1>;
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseStandingOrderV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters
     */
    'standingOrders'?: Array<ValidateCurrentAccountBasicTerminationResponseStandingOrderV1>;
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseSipoV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1AllOfMessageParameters
     */
    'sipo'?: Array<ValidateCurrentAccountBasicTerminationResponseSipoV1>;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOf
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1AllOfMessageParameters
     */
    'terminationDate'?: string;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseExistingTransitionV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseExistingTransitionV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseExistingTransitionV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ValidateCurrentAccountBasicTerminationResponseLevelV1 = {
    ERROR: 'ERROR',
    MESSAGE: 'MESSAGE'
} as const;

export type ValidateCurrentAccountBasicTerminationResponseLevelV1 = typeof ValidateCurrentAccountBasicTerminationResponseLevelV1[keyof typeof ValidateCurrentAccountBasicTerminationResponseLevelV1];


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseLoanProductExistsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseLoanProductExistsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseLoanProductExistsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOf
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters
 */
export interface ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters {
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters
     */
    'overdraftDebitAmount': AmountIsoCurrencyV2x0;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1AllOfMessageParameters
     */
    'latestOverdraftSettlementDate': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1 = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    SEMI_ANNUALLY: 'SEMI_ANNUALLY',
    ANNUALLY: 'ANNUALLY'
} as const;

export type ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1 = typeof ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1[keyof typeof ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1];


/**
 * @type ValidateCurrentAccountBasicTerminationResponseResultItemV1
 * @export
 */
export type ValidateCurrentAccountBasicTerminationResponseResultItemV1 = { type: 'BALANCE_IN_DEBIT' } & ValidateCurrentAccountBasicTerminationResponseBalanceInDebitV1 | { type: 'BLOCKING_EXISTS' } & ValidateCurrentAccountBasicTerminationResponseBlockingExistsV1 | { type: 'CARD_EXISTS' } & ValidateCurrentAccountBasicTerminationResponseCardExistsV1 | { type: 'EXECUTION_EXISTS' } & ValidateCurrentAccountBasicTerminationResponseExecutionExistsV1 | { type: 'EXISTING_PAYMENTS' } & ValidateCurrentAccountBasicTerminationResponseExistingPaymentsV1 | { type: 'EXISTING_TERMINATION' } & ValidateCurrentAccountBasicTerminationResponseExistingTerminationV1 | { type: 'EXISTING_TRANSITION' } & ValidateCurrentAccountBasicTerminationResponseExistingTransitionV1 | { type: 'LOAN_PRODUCT_EXISTS' } & ValidateCurrentAccountBasicTerminationResponseLoanProductExistsV1 | { type: 'OVERDRAFT_IN_CREDIT' } & ValidateCurrentAccountBasicTerminationResponseOverdraftInCreditV1 | { type: 'OVERDRAFT_IN_DEBIT' } & ValidateCurrentAccountBasicTerminationResponseOverdraftInDebitV1 | { type: 'SHARED_PRODUCT_NOTIFICATION' } & ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1 | { type: 'SUBACCOUNT_EXISTS' } & ValidateCurrentAccountBasicTerminationResponseSubAccountExistsV1;

/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOf
 */
export interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOf {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOf
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOf
     */
    'messageParameters': ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters
 */
export interface ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSharedProductNotificationV1AllOfMessageParameters
     */
    'coOwnerName': string;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSipoV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseSipoV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSipoV1
     */
    'sipoName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSipoV1
     */
    'connectionNumber': string;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSipoV1
     */
    'amountLimit': AmountIsoCurrencyV2x0;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseStandingOrderV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'standingOrderName': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'paymentCodes': string;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'recipient': ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'amount': AmountIsoCurrencyV2x0;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'periodicity': ValidateCurrentAccountBasicTerminationResponsePaymentPeriodicityV1;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseStandingOrderV1
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSubAccountExistsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseSubAccountExistsV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseLevelV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSubAccountExistsV1
     */
    'level': ValidateCurrentAccountBasicTerminationResponseLevelV1;
}


/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseSubAccountsV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseSubAccountsV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseSubAccountsV1
     */
    'accountUuid': string;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1 {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1
     */
    'iban': string;
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant}
     * @memberof ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1
     */
    'merchant'?: ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant
 */
export interface ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant {
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant
     */
    'merchantUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateCurrentAccountBasicTerminationResponseTerminationRecipientV1Merchant
     */
    'category': string;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseV1 {
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseValidationResultV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseV1
     */
    'validationResults': Array<ValidateCurrentAccountBasicTerminationResponseValidationResultV1>;
}
/**
 * 
 * @export
 * @interface ValidateCurrentAccountBasicTerminationResponseValidationResultV1
 */
export interface ValidateCurrentAccountBasicTerminationResponseValidationResultV1 {
    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationResponseAccountDetailV1}
     * @memberof ValidateCurrentAccountBasicTerminationResponseValidationResultV1
     */
    'accountDetail': ValidateCurrentAccountBasicTerminationResponseAccountDetailV1;
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseResultItemV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseValidationResultV1
     */
    'results': Array<ValidateCurrentAccountBasicTerminationResponseResultItemV1>;
    /**
     * 
     * @type {Array<ValidateCurrentAccountBasicTerminationResponseSubAccountsV1>}
     * @memberof ValidateCurrentAccountBasicTerminationResponseValidationResultV1
     */
    'subAccounts'?: Array<ValidateCurrentAccountBasicTerminationResponseSubAccountsV1>;
}


/**
 * CurrentAccountBasicTerminationApi - axios parameter creator
 * @export
 */
export const CurrentAccountBasicTerminationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Close Date Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetCloseDateCurrentAccountBasicTerminationRequestV1} getCloseDateCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCloseDateCurrentAccountBasicTerminationV1: async (authorization: string, xCorrelationId: string, getCloseDateCurrentAccountBasicTerminationRequestV1: GetCloseDateCurrentAccountBasicTerminationRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCloseDateCurrentAccountBasicTerminationV1', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCloseDateCurrentAccountBasicTerminationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'getCloseDateCurrentAccountBasicTerminationRequestV1' is not null or undefined
            assertParamExists('getCloseDateCurrentAccountBasicTerminationV1', 'getCloseDateCurrentAccountBasicTerminationRequestV1', getCloseDateCurrentAccountBasicTerminationRequestV1)
            const localVarPath = `/bank-termination-account-cab-boa/v1/get-close-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCloseDateCurrentAccountBasicTerminationRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Settlement Account Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetSettlementAccountCurrentAccountBasicTerminationRequestV1} getSettlementAccountCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementAccountCurrentAccountBasicTerminationV1: async (authorization: string, xCorrelationId: string, getSettlementAccountCurrentAccountBasicTerminationRequestV1: GetSettlementAccountCurrentAccountBasicTerminationRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSettlementAccountCurrentAccountBasicTerminationV1', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getSettlementAccountCurrentAccountBasicTerminationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'getSettlementAccountCurrentAccountBasicTerminationRequestV1' is not null or undefined
            assertParamExists('getSettlementAccountCurrentAccountBasicTerminationV1', 'getSettlementAccountCurrentAccountBasicTerminationRequestV1', getSettlementAccountCurrentAccountBasicTerminationRequestV1)
            const localVarPath = `/bank-termination-account-cab-boa/v1/get-settlement-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSettlementAccountCurrentAccountBasicTerminationRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Prepare Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {PrepareCurrentAccountBasicTerminationRequestV1} prepareCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareCurrentAccountBasicTerminationV1: async (authorization: string, xCorrelationId: string, prepareCurrentAccountBasicTerminationRequestV1: PrepareCurrentAccountBasicTerminationRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('prepareCurrentAccountBasicTerminationV1', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('prepareCurrentAccountBasicTerminationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'prepareCurrentAccountBasicTerminationRequestV1' is not null or undefined
            assertParamExists('prepareCurrentAccountBasicTerminationV1', 'prepareCurrentAccountBasicTerminationRequestV1', prepareCurrentAccountBasicTerminationRequestV1)
            const localVarPath = `/bank-termination-account-cab-boa/v1/prepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareCurrentAccountBasicTerminationRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {ValidateCurrentAccountBasicTerminationRequestV1} validateCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCurrentAccountBasicTerminationV1: async (authorization: string, xCorrelationId: string, validateCurrentAccountBasicTerminationRequestV1: ValidateCurrentAccountBasicTerminationRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('validateCurrentAccountBasicTerminationV1', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('validateCurrentAccountBasicTerminationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'validateCurrentAccountBasicTerminationRequestV1' is not null or undefined
            assertParamExists('validateCurrentAccountBasicTerminationV1', 'validateCurrentAccountBasicTerminationRequestV1', validateCurrentAccountBasicTerminationRequestV1)
            const localVarPath = `/bank-termination-account-cab-boa/v1/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateCurrentAccountBasicTerminationRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrentAccountBasicTerminationApi - functional programming interface
 * @export
 */
export const CurrentAccountBasicTerminationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrentAccountBasicTerminationApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Close Date Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetCloseDateCurrentAccountBasicTerminationRequestV1} getCloseDateCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCloseDateCurrentAccountBasicTerminationV1(authorization: string, xCorrelationId: string, getCloseDateCurrentAccountBasicTerminationRequestV1: GetCloseDateCurrentAccountBasicTerminationRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCloseDateCurrentAccountBasicTerminationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCloseDateCurrentAccountBasicTerminationV1(authorization, xCorrelationId, getCloseDateCurrentAccountBasicTerminationRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Settlement Account Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetSettlementAccountCurrentAccountBasicTerminationRequestV1} getSettlementAccountCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettlementAccountCurrentAccountBasicTerminationV1(authorization: string, xCorrelationId: string, getSettlementAccountCurrentAccountBasicTerminationRequestV1: GetSettlementAccountCurrentAccountBasicTerminationRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSettlementAccountCurrentAccountBasicTerminationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettlementAccountCurrentAccountBasicTerminationV1(authorization, xCorrelationId, getSettlementAccountCurrentAccountBasicTerminationRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Prepare Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {PrepareCurrentAccountBasicTerminationRequestV1} prepareCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareCurrentAccountBasicTerminationV1(authorization: string, xCorrelationId: string, prepareCurrentAccountBasicTerminationRequestV1: PrepareCurrentAccountBasicTerminationRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareCurrentAccountBasicTerminationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareCurrentAccountBasicTerminationV1(authorization, xCorrelationId, prepareCurrentAccountBasicTerminationRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate Current Account Basic
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {ValidateCurrentAccountBasicTerminationRequestV1} validateCurrentAccountBasicTerminationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCurrentAccountBasicTerminationV1(authorization: string, xCorrelationId: string, validateCurrentAccountBasicTerminationRequestV1: ValidateCurrentAccountBasicTerminationRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCurrentAccountBasicTerminationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCurrentAccountBasicTerminationV1(authorization, xCorrelationId, validateCurrentAccountBasicTerminationRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CurrentAccountBasicTerminationApi - factory interface
 * @export
 */
export const CurrentAccountBasicTerminationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrentAccountBasicTerminationApiFp(configuration)
    return {
        /**
         * Get Close Date Current Account Basic
         * @param {CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCloseDateCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetCloseDateCurrentAccountBasicTerminationResponseV1> {
            return localVarFp.getCloseDateCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.getCloseDateCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get Settlement Account Current Account Basic
         * @param {CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementAccountCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetSettlementAccountCurrentAccountBasicTerminationResponseV1> {
            return localVarFp.getSettlementAccountCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.getSettlementAccountCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Prepare Current Account Basic
         * @param {CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<PrepareCurrentAccountBasicTerminationResponseV1> {
            return localVarFp.prepareCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.prepareCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Validate Current Account Basic
         * @param {CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ValidateCurrentAccountBasicTerminationResponseV1> {
            return localVarFp.validateCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.validateCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCloseDateCurrentAccountBasicTerminationV1 operation in CurrentAccountBasicTerminationApi.
 * @export
 * @type CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request
 */
export type CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request = {
    /**
     * 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {GetCloseDateCurrentAccountBasicTerminationRequestV1}
     * @memberof CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1
     */
    readonly getCloseDateCurrentAccountBasicTerminationRequestV1: GetCloseDateCurrentAccountBasicTerminationRequestV1
}

/**
 * Request parameters for getSettlementAccountCurrentAccountBasicTerminationV1 operation in CurrentAccountBasicTerminationApi.
 * @export
 * @type CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request
 */
export type CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request = {
    /**
     * 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {GetSettlementAccountCurrentAccountBasicTerminationRequestV1}
     * @memberof CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1
     */
    readonly getSettlementAccountCurrentAccountBasicTerminationRequestV1: GetSettlementAccountCurrentAccountBasicTerminationRequestV1
}

/**
 * Request parameters for prepareCurrentAccountBasicTerminationV1 operation in CurrentAccountBasicTerminationApi.
 * @export
 * @type CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request
 */
export type CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request = {
    /**
     * 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {PrepareCurrentAccountBasicTerminationRequestV1}
     * @memberof CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1
     */
    readonly prepareCurrentAccountBasicTerminationRequestV1: PrepareCurrentAccountBasicTerminationRequestV1
}

/**
 * Request parameters for validateCurrentAccountBasicTerminationV1 operation in CurrentAccountBasicTerminationApi.
 * @export
 * @type CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request
 */
export type CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request = {
    /**
     * 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {ValidateCurrentAccountBasicTerminationRequestV1}
     * @memberof CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1
     */
    readonly validateCurrentAccountBasicTerminationRequestV1: ValidateCurrentAccountBasicTerminationRequestV1
}

/**
 * CurrentAccountBasicTerminationApi - object-oriented interface
 * @export
 * @class CurrentAccountBasicTerminationApi
 * @extends {BaseAPI}
 */
export class CurrentAccountBasicTerminationApi extends BaseAPI {
    /**
     * Get Close Date Current Account Basic
     * @param {CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentAccountBasicTerminationApi
     */
    public getCloseDateCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiGetCloseDateCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CurrentAccountBasicTerminationApiFp(this.configuration).getCloseDateCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.getCloseDateCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Settlement Account Current Account Basic
     * @param {CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentAccountBasicTerminationApi
     */
    public getSettlementAccountCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiGetSettlementAccountCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CurrentAccountBasicTerminationApiFp(this.configuration).getSettlementAccountCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.getSettlementAccountCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Prepare Current Account Basic
     * @param {CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentAccountBasicTerminationApi
     */
    public prepareCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiPrepareCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CurrentAccountBasicTerminationApiFp(this.configuration).prepareCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.prepareCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate Current Account Basic
     * @param {CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentAccountBasicTerminationApi
     */
    public validateCurrentAccountBasicTerminationV1(requestParameters: CurrentAccountBasicTerminationApiValidateCurrentAccountBasicTerminationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CurrentAccountBasicTerminationApiFp(this.configuration).validateCurrentAccountBasicTerminationV1(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.validateCurrentAccountBasicTerminationRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


